import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 能源计划
 */
const energyPlan = {

  /**
   * 创建
   */
  createEnergyPlan (companyId, name, startTime, timeGranularity) {
    return axios.post(base.energyPlan.createEnergyPlan, utils.postParamsArrayToJsonString({ companyId, name, startTime, timeGranularity }))
  },
  /**
   * 修改
   */
  modifyEnergyPlan (id, name, startTime, timeGranularity) {
    return axios.post(base.energyPlan.modifyEnergyPlan, utils.postParamsArrayToJsonString({ id, name, startTime, timeGranularity }))
  },
  /**
   * 删除
   */
  deleteEnergyPlan (id) {
    return axios.post(base.energyPlan.deleteEnergyPlan, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getEnergyPlan (companyId, startTime, endTime) {
    return axios.post(base.energyPlan.getEnergyPlan, utils.postParamsArrayToJsonString({ companyId, startTime, endTime }))
  },
  /**
   * 创建
   */
  addEnergyPlanDesire (measureId, pointCode, pointNumber, desiredValue, compare, planId) {
    return axios.post(base.energyPlan.addEnergyPlanDesire, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, desiredValue, compare, planId }))
  },
  /**
   * 修改
   */
  modifyEnergyPlanDesire (id, measureId, pointCode, pointNumber, desiredValue, compare) {
    return axios.post(base.energyPlan.modifyEnergyPlanDesire, utils.postParamsArrayToJsonString({ id, measureId, pointCode, pointNumber, desiredValue, compare }))
  },
  /**
   * 删除
   */
  deleteEnergyPlanDesire (id) {
    return axios.post(base.energyPlan.deleteEnergyPlanDesire, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getEnergyPlanDesires (planId) {
    return axios.post(base.energyPlan.getEnergyPlanDesires, utils.postParamsArrayToJsonString({ planId }))
  },
  /**
   * 设置
   */
  setEnergyPlanDesires (planId, desires) {
    return axios.post(base.energyPlan.setEnergyPlanDesires, utils.postParamsArrayToJsonString({ planId, desires }))
  },
  /**
   * 查询计划报告
   */
  reportEnergyPlan (planId) {
    return axios.post(base.energyPlan.reportEnergyPlan, utils.postParamsArrayToJsonString({ planId }))
  },
}

export default energyPlan